import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SiteType } from '@shared/models';
import theme from '@styles/theme';
import { Theme } from '@material-ui/core';

const MARKER_SIZE = 16;

const useStyles = makeStyles<Theme, { size: number; isStatic?: boolean }>({
  outer: ({ size, isStatic }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(106, 112, 130, 0.6)',
    height: size + 6,
    width: size + 6,
    padding: theme.spacing(0.25),
    position: isStatic ? 'relative' : 'absolute',
  }),
  outerOnMap: ({ size }) => ({
    transform: `translate(${-(size + 6) / 2}px,${-(size + 6) / 2}px)`,
  }),
  inner: ({ size }) => ({
    padding: theme.spacing(0.25),
    height: size,
    width: size,
  }),
  square: {
    borderRadius: 2,
  },
  circle: {
    borderRadius: 24,
  },
});

export interface SiteDotMarkerProps {
  color: string;
  title?: string;
  siteType?: SiteType;
  showOnMap?: boolean;
  hidePointerCursor?: boolean;
  small?: boolean;
}

export const SiteDotMarker: React.FC<SiteDotMarkerProps> = ({
  color,
  title,
  siteType,
  showOnMap,
  hidePointerCursor = false,
  small,
}) => {
  const size = MARKER_SIZE + (small ? -4 : 0);

  const classes = useStyles({ size, isStatic: !showOnMap });

  const shapeClass = siteType === 'PRV' ? classes.square : classes.circle;

  return (
    <div className={`relative ${hidePointerCursor ? 'cursor-default' : ''}`} title={title ?? ''}>
      <div
        className={`${classes.outer} ${shapeClass} ${showOnMap ? classes.outerOnMap : ''}`}
        style={{ margin: 'auto' }}
      >
        <div
          className={`${classes.inner} ${shapeClass} flex justify-center items-center text-white text-sm transform`}
          style={{ backgroundColor: color }}
        />
      </div>
    </div>
  );
};
